import { render, staticRenderFns } from "./batch-approval-detail.vue?vue&type=template&id=3043981b&scoped=true"
import script from "./batch-approval-detail.vue?vue&type=script&lang=js"
export * from "./batch-approval-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3043981b",
  null
  
)

export default component.exports